import { Subscription } from '../../entities';

export type UserSubscriptionsState = {
  hasSubscription: boolean;
  subscriptions: Array<Subscription>;
};

export const userSubscriptionsInitialState: UserSubscriptionsState = {
  hasSubscription: false,
  subscriptions: [],
};
